export enum AlertType {
  failure = 'failure',
  warning = 'warning'
}

export interface IAlertPayload {
  message: string
  type: AlertType
  canBeDismissed: boolean
}
